var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSixteen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1f3060;\n      }\n\n      .cls-2 {\n        fill: #ccc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M714.51,87.87c-153.81,0-278.49,124.68-278.49,278.49,0,6.56.54,12.97.97,19.41l32.79-32.77,309.73,283.92c122.38-29.33,213.48-139.17,213.48-270.55,0-153.81-124.68-278.49-278.49-278.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M666.84,533.61c15.18,4.33,31.12,6.81,47.67,6.81,95.97,0,174.05-78.08,174.05-174.05s-78.08-174.05-174.05-174.05-174.05,78.08-174.05,174.05c0,21.9,4.23,42.77,11.64,62.09l114.74,105.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M469.79,352.99l36.81,33.73c-.5-6.74-.96-13.49-.96-20.36,0-141.99,106.35-258.92,243.68-276.09-11.44-1.43-22.99-2.4-34.81-2.4-153.81,0-278.49,124.68-278.49,278.49,0,6.56.54,12.97.97,19.41l32.79-32.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M770.21,306.68v-39.77h-37.13v-39.79h-37.14v39.79h-37.13v119.35h74.27v39.79h-74.27v39.77h37.13v39.79h37.14v-39.79h37.13v-119.35h-74.27v-39.79h74.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.91,992.96h139.24v-507.74l-139.24-139.24v646.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.97,992.96h139.24v-333.68l-139.24-139.24v472.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M436.02,624.45v368.51h139.24v-311.71l-103.18-92.86-36.06,36.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M749.32,874.1v-36.2l-139.24-125.32v280.38h139.24v-69.62h-49.24l49.24-49.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M784.13,923.34h139.24v69.62h-139.24v-69.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.91,345.98v646.98h69.62V415.6l-69.62-69.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M261.97,520.03v472.92h69.62v-403.3l-69.62-69.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M508.74,621.37l-36.66-32.98-36.06,36.06v368.51h69.62v-368.51l3.1-3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M610.08,712.57v280.38h69.62v-217.73l-69.62-62.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M784.13,923.34h69.62v69.62h-69.62v-69.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.54,227.12l243.68,243.68,69.62-69.62,417.73,382.92,34.81-34.81v139.24h-139.24l34.81-34.81-348.11-313.3-69.62,69.62L87.91,296.74v-69.62h69.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M157.54,296.74v-69.62h-69.62v69.62l313.3,313.3,34.81-34.81L157.54,296.74Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixteen);
export default __webpack_public_path__ + "static/media/sixteen.6a09366ed4e963bb55ccef56f19914d6.svg";
export { ForwardRef as ReactComponent };